import * as turf from "@turf/turf";
import { DivIcon, icon, LatLngExpression, PointExpression } from "leaflet";
import { useState } from "react";
import { renderToString } from "react-dom/server";
import { Marker } from "react-leaflet";
import { useParams } from "react-router-dom";

import TransformedImage from "./TransformedImage";

import { LayerAlias } from "constant";
import { downloadImage } from "services/api/units";

import PhotoMarkerIcon from "assets/icons/photo-marker.svg";

import { useLabelingContext } from "context/LabelingContextProvider";
import styles from "./photo-marker.module.scss";

interface PhotoMarkerInterface {
  data: {
    url: any;
    status: string;
    id: string;
    geo_json: {
      coordinates: any;
      type: string;
    };
  };
  isActive: boolean;
  onActivate: (id: string) => void;
}

const PhotoMarker = ({ data, isActive, onActivate }: PhotoMarkerInterface) => {
  const { id: projectId } = useParams();
  const { clearPolygonPoints } = useLabelingContext();

  var polygon = turf.polygon([
    [...data.geo_json.coordinates[0], data.geo_json.coordinates[0][0]]
  ]);

  var centroid = turf.centroid(polygon);

  const [img, setImage] = useState(null);

  if (img && isActive)
    return (
      <TransformedImage
        img={img}
        corners={[
          data.geo_json.coordinates[0][0],
          data.geo_json.coordinates[0][1],
          data.geo_json.coordinates[0][3],
          data.geo_json.coordinates[0][2]
        ]}
      />
    );

  const getLoadingMarker = () => {
    const iconSize: PointExpression = [23, 23];
    const iconAnchor: PointExpression = [0, 0];
    return new DivIcon({
      html: renderToString(
        <div className={styles["marker-loader"]}>
          <div className={styles["loader"]} />
        </div>
      ),
      className: "marker-reset",
      iconSize,
      iconAnchor
    });
  };

  return (
    <Marker
      position={centroid.geometry.coordinates as LatLngExpression}
      icon={
        data.status === "processing"
          ? getLoadingMarker()
          : icon({ iconUrl: PhotoMarkerIcon })
      }
      eventHandlers={{
        click: () => {
          clearPolygonPoints();
          if (isActive) return;
          onActivate(data.id);
          if (data.url) setImage(data.url);
          else
            downloadImage({
              params: { projectId, alias: LayerAlias.RGB2 },
              fields: {
                ids: [data.id]
              }
            });
        }
      }}
    />
  );
};

export default PhotoMarker;
